namespace Gamification.Gamification {
    export enum ApiScriptUtenteOperazioniEnum {
        Indefinita = 0,
        Memorizza_Dati_Utente = 1,
        Mostra_Punteggio = 2,
        Mostra_Crediti = 3,
        Mostra_Punti_Esperienza = 4,
        Mostra_Livello = 5
    }
    Serenity.Decorators.registerEnumType(ApiScriptUtenteOperazioniEnum, 'Gamification.Gamification.ApiScriptUtenteOperazioniEnum');
}
